import { ElementType } from './types';

const defaultFontFamily = 'Roboto';
// Every font here must also be loaded in public/index.html: players show
// slides through the same web app.
const fontGroups = [
  {
    label: 'Sans serif',
    fonts: [
      'Roboto',
      'Open Sans',
      'Montserrat',
      'Lato',
      'Poppins',
      'Raleway',
      'Nunito',
      'Work Sans',
      'Oswald',
    ],
  },
  {
    label: 'Serif',
    fonts: ['Playfair Display', 'Merriweather', 'Lora', 'Roboto Slab'],
  },
  {
    label: 'Display',
    fonts: ['Bebas Neue', 'Anton', 'Archivo Black', 'Lobster', 'Pacifico'],
  },
  {
    label: 'Handwriting',
    fonts: ['Great Vibes', 'Dancing Script', 'Allison', 'Caveat'],
  },
  { label: 'Monospace', fonts: ['Roboto Mono'] },
];
// Not flatMap: players import this module and some TV browsers lack it.
const fontFamilies = fontGroups.reduce<string[]>(
  (fonts, group) => fonts.concat(group.fonts),
  [],
);
const IFRAME_WIDGETS = {
  IFRAME: 'iframe',
  WORLD_CLOCK: 'world-clock',
  DATE: 'date',
};
const ELEMENTS: ElementType = {
  date: ['date', 'background'],
  'world-clock': ['digits', 'background'],
};
// Properties serialized with each object for history snapshots and saves.
const CANVAS_JSON_PROPS = [
  'data',
  'id',
  'deviceInfo',
  'lockMovementX',
  'lockMovementY',
  'lockRotation',
  'lockScalingX',
  'lockScalingY',
  'editable',
];
const NEWS_TYPES = {
  CNN: 'cnn',
  BBC: 'bbc',
};

export {
  defaultFontFamily,
  fontFamilies,
  fontGroups,
  IFRAME_WIDGETS,
  ELEMENTS,
  NEWS_TYPES,
  CANVAS_JSON_PROPS,
};
